<template src="./taxDetailVue.template.html"></template>
<script>
export default {
  name: "taxDetailComponent",
  props: [],
  data() {
    return {
      statusList: [],
      statusId: 1,
      ledgerAccountList: [],
      tax_Status: {},
      taxItemDetail: {},
      ledgerAccountApplyList: [],
      noPercent: "",
      yesPercent: "",
      displaySectionValue: "TaxItemInfo",
      isBgColor1: true,
      isBgColor2: false,
      showLedgerAccounts: false,
      taxLedgerAccountsList: [],
      taxAsExempt: "",
      taxAsVat: "",
      taxItemValue: "",
      propertyId: "",
      categoryName: null
    };
  },

  methods: {
    getStatusIdInList() {
      let scope = this;
      scope.taxItemDetail.StatusId = scope.statusId;
    },
    //differntiate the color for the sections
    displaySection: function(name) {
      if (name === "TaxItemInfo") {
        this.isBgColor1 = true;
        this.isBgColor2 = false;
        this.showLedgerAccounts = false;
      }
      if (name === "AppliedLedgerAccounts") {
        this.isBgColor2 = true;
        this.isBgColor1 = false;
        this.getTaxLedgerAccounts();
      }
      this.displaySectionValue = name;
    },

    //getting the taxitem details by taxitem id
    getTaxDetailByid() {
      let scope = this;

      scope.$store.dispatch("dataRequestHandler", {
        key: "GetTaxDetailById",
        params: {
          ModuleAction: "GetTaxDetailById",
          taxId: scope.$route.params.taxId,
          PropertyId: scope.$route.params.propertyId,
          statusId: scope.$route.params.statusId
        },
        callback: function(err, response) {
          scope.ledgerAccountList = response.recordsets[0];

          if (response.recordsets[1].length > 0) {
            scope.statusList = response.recordsets[1];

            //checking the status and displaying the defalut status if the response has 0 status
            scope.tax_Status =
              response.recordsets[2][0].StatusId === 1 ||
              response.recordsets[2][0].StatusId === null ||
              response.recordsets[2][0].StatusId === undefined ||
              response.recordsets[2][0].StatusId === ""
                ? { StatusId: "1", StatusName: "Active" }
                : {
                    StatusId: response.recordsets[2][0].StatusId,
                    StatusName: response.recordsets[2][0].StatusName
                  };
          }
          console.log("taxItemDetail", response.recordsets[2][0]);
          scope.taxItemDetail = response.recordsets[2][0];
          scope.categoryName = scope.taxItemDetail.Category;
          scope.taxItemValue = response.recordsets[2][0].TaxItemValue;
          // scope.$set(scope.tax_Status,'StatusId', response.recordsets[2][0].StatusId);
          // scope.$set(scope.tax_Status,'StatusName', response.recordsets[2][0].StatusName);
          if (scope.taxItemDetail.IsPercent == true) {
            scope.taxItemDetail.TaxItemValue =
              scope.taxItemDetail.TaxItemValue + "%";
            scope.yesPercent = true;
          } else {
            scope.taxItemDetail.TaxItemValue =
              "$" + scope.taxItemDetail.TaxItemValue;
            scope.taxItemDetail.IsPercent = false;
            scope.noPercent = true;
          }

          if (scope.taxItemDetail.IsVAT == null) {
            scope.taxAsVat = "";
          } else if (scope.taxItemDetail.IsVAT == true) {
            scope.taxAsVat = "Calculated As VAT";
          } else {
            scope.taxAsVat = "Not Calculated As VAT";
            scope.taxItemDetail.IsVAT = false;
          }

          if (scope.taxItemDetail.TaxExempt == null) {
            scope.taxAsExempt = "";
          } else if (scope.taxItemDetail.TaxExempt == true) {
            scope.taxAsExempt = "Tax Exempt";
          } else {
            scope.taxAsExempt = "No Tax Exempt";
            scope.taxItemDetail.TaxExempt = false;
          }

          if (scope.taxItemDetail.TaxItemId != -1) {
            scope.ledgerAccountApplyList = response.recordsets[3];
          }
          if (scope.taxItemDetail.length !== 0) {
            // scope.statusList = response.recordsets[1];

            scope.taxItemDetail.StatusId =
              scope.taxItemDetail.StatusId === null ||
              scope.taxItemDetail.StatusId === undefined ||
              scope.taxItemDetail.StatusId === ""
                ? "1"
                : scope.taxItemDetail.StatusId;
          }
        }
      });
    },

    getpropertyId() {
      let scope = this;
      scope.propertyId = scope.$route.params.propertyId;
    },

    addPercent(taxItemDetail) {
      let scope = this;
      if (scope.taxItemDetail.TaxItemValue.indexOf("$") > -1) {
        scope.taxItemDetail.TaxItemValue = scope.taxItemDetail.TaxItemValue.replace(
          "$",
          ""
        );
        scope.taxItemDetail.TaxItemValue =
          scope.taxItemDetail.TaxItemValue + "%";
      }
      scope.taxItemDetail.IsPercent = true;
      scope.noPercent = false;
      scope.yesPercent = true;
    },
    addDollar(taxItemDetail) {
      let scope = this;
      if (scope.taxItemDetail.TaxItemValue.indexOf("%") > -1) {
        scope.taxItemDetail.TaxItemValue = scope.taxItemDetail.TaxItemValue.replace(
          "%",
          ""
        );
      }
      scope.taxItemDetail.TaxItemValue = "$" + scope.taxItemDetail.TaxItemValue;
      scope.taxItemDetail.IsPercent = false;
      scope.noPercent = true;
      scope.yesPercent = false;
    },

    taxExemptcheck(e) {
      let scope = this;
      if (e.target.checked) {
        scope.taxAsExempt = "Tax Exempt";
        scope.taxItemDetail.TaxExempt = true;
      } else {
        scope.taxAsExempt = "No Tax Exempt";
        scope.taxItemDetail.TaxExempt = false;
      }
    },

    isVATcheck(e) {
      let scope = this;
      if (e.target.checked) {
        scope.taxAsVat = "Calculated As VAT";
        scope.taxItemDetail.IsVAT;
        scope.taxItemDetail.IsVAT = true;
      } else {
        scope.taxAsVat = "Not Calculated As VAT";
        scope.taxItemDetail.IsVAT = false;
      }
    },

    saveTaxItemValue() {
      let scope = this;
      if (scope.taxItemDetail.IsPercent == 1) {
        scope.taxItemDetail.TaxItemValue = scope.taxItemValue + "%";
      } else {
        scope.taxItemDetail.TaxItemValue = "$" + scope.taxItemValue;
      }
    },

    saveTaxItemsDetails() {
      let scope = this;
      if (
        scope.taxItemDetail.TaxItemName === "" ||
        (scope.taxItemDetail.TaxItemName === undefined ||
          (scope.taxItemValue === "" || scope.taxItemValue === undefined) ||
          (scope.taxItemDetail.CategoryId === "" ||
            scope.taxItemDetail.CategoryId === undefined))
      ) {
        scope.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "TaxItemName,  TaxItemValue, Category are mandatary"
        });
      } else {
        scope.$store.dispatch("dataRequestHandler", {
          key: "saveTaxItemsDetails",
          params: {
            ModuleAction: "saveTaxItemsDetails",
            TaxItemId: scope.taxItemDetail.TaxItemId,
            PropertyId: scope.propertyId,
            TaxItemName: scope.taxItemDetail.TaxItemName,
            TaxItemDisplayName: scope.taxItemDetail.TaxItemDisplayName,
            TaxItemDesc: scope.taxItemDetail.TaxItemDescription,
            StatusId: scope.tax_Status.StatusId,
            TaxItemValue: scope.taxItemValue,
            IsPercent: scope.taxItemDetail.IsPercent,
            TaxExempt: scope.taxItemDetail.TaxExempt,
            IsVAT: scope.taxItemDetail.IsVAT,
            LedgerAccountId: scope.taxItemDetail.CategoryId
          },
          callback: function(err, response) {
            if (err) {
              console.log(err);
              scope.$store.dispatch("toastr", {
                type: "error",
                header: "Tax Item Detail Error!",
                message: err.sqlMessage ? err.sqlMessage : err
              });
              return;
            } else if (response) {
              // else if (response) {
              //   scope.$store.dispatch("toastr", {
              //     type: "success",
              //     header: "Success!",
              //     message: "Tax Item successfully saved"
              //   });
              //   scope.taxItemDetail.TaxItemId =
              //     response.recordsets[0][0].TaxItemId;
              // }
              console.log("taxresponse --->", response);
              if (
                (response.recordsets[1][0] &&
                  response.recordsets[0][0].ERRORMESSAGE === "") ||
                response.recordsets[0][0].ERRORMESSAGE === null ||
                response.recordsets[0][0].ERRORMESSAGE === "null"
              ) {
                scope.taxItemDetail.TaxItemId =
                  response.recordsets[1][0].TaxItemId;
                scope.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Tax Item successfully saved"
                });
              } else {
                scope.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error While saving",
                  message: response.recordsets[0][0].ERRORMESSAGE
                });
              }
            }
            console.log("saveTaxdetailsid", scope.taxItemDetail.TaxItemId);
            let TaxItemId = response.recordsets[1][0].TaxItemId;
            let PropertyId = response.recordsets[1][0].PropertyId;

            let StatusId = response.recordsets[1][0].StatusId;
            scope.$router.push(
              "/taxDetail/" + TaxItemId + "/" + PropertyId + "/" + StatusId
            );
            if (response.recordsets[2] && response.recordsets[2].length > 0) {
              for (let syncRUUnitIndex of response.recordsets[2]) {
                if (
                  syncRUUnitIndex.syncToRU == 1 &&
                  syncRUUnitIndex.SyncUnit
                ) {
                  scope.syncUnitToRU("Property Sync", syncRUUnitIndex.SyncUnit);
                }
              }
            }
            // else {
            //   console.log(err);
            //   scope.$store.dispatch("toastr", {
            //     type: "error",
            //     header: "Tax Item Detail Error!",
            //     message: err.sqlMessage ? err.sqlMessage : err
            //   });
            //   return;
            // }
            // let taxItemDetail = response.recordsets[0][0].taxItemDetail;
            //           let PropertyId = response.recordsets[0][0].PropertyId;
            //           let StatusId = response.recordsets[0][0].StatusId;
            //           let StatusId = response.recordsets[0][0].StatusId;
            //       vm.$router.push("/taxDetail/" + taxItemDetail + "/" + PropertyId + "/"+ StatusId );
          }
        });
      }
    },

    // showLedgerAccountList() {
    //   this.showLedgerAccounts = !this.showLedgerAccounts;
    // },
    syncUnitToRU(messageType, unitId) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "syncUnitToRU",
        params: {
          UnitId: unitId,
          // CrsPropertyId: vm.crsPropertyId,
          MessageType: messageType,
          CrsId: 2
        },
        callback: function(error, response) {
          console.log("unit1 response", response);
        }
      });
    },
    showLedgerAccountList() {
      setTimeout(function() {
        this.showLedgerAccounts = !this.showLedgerAccounts;
        $("#taxDropDown").show();
      }, 10);
    },

    saveTaxLedgerAccounts() {
      let scope = this;
      scope.showLedgerAccounts = false;
      console.log(
        "scope.taxItemDetail.TaxItemId",
        scope.taxItemDetail.TaxItemId
      );
      scope.$store.dispatch("dataRequestHandler", {
        key: "saveTaxLedgerAccounts",
        params: {
          ModuleAction: "saveTaxLedgerAccounts",
          TaxItemId: scope.taxItemDetail.TaxItemId,
          LedgerAccounts: scope.ledgerAccountApplyList,
          PropertyId: scope.$route.params.propertyId
        },
        callback: function(err, response) {
          if (response) {
            scope.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "Tax Ledger Accounts successfully saved"
            });
            scope.getTaxLedgerAccounts();
          } else {
            console.log(err);
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Tax Ledger Accounts Detail Error!",
              message: err.sqlMessage ? err.sqlMessage : err
            });
            return;
          }
        }
      });
    },

    getTaxLedgerAccounts() {
      let scope = this;
      scope.$store.dispatch("dataRequestHandler", {
        key: "getTaxLedgerAccounts",
        params: {
          ModuleAction: "getTaxLedgerAccounts"
        },
        callback: function(err, response) {
          if (response) {
            scope.taxLedgerAccountsList = response.recordsets[0];

            function findIndexByKeyValue(arraytosearch, key, valuetosearch) {
              for (var i = 0; i < arraytosearch.length; i++) {
                if (arraytosearch[i][key] == valuetosearch) {
                  return i;
                }
              }
              return null;
            }

            for (var i in scope.ledgerAccountApplyList) {
              var ledgerAccountApplyIndex = findIndexByKeyValue(
                scope.taxLedgerAccountsList,
                "ledgerAccountID",
                scope.ledgerAccountApplyList[i].LedgerAccountId
              );
              if (ledgerAccountApplyIndex > -1) {
                scope.taxLedgerAccountsList.splice(ledgerAccountApplyIndex, 1);
              }
            }
          } else {
            console.log(err);
          }
        }
      });
    },

    addLedgerAccount(TaxLedgerAccount) {
      let scope = this;
      scope.ledgerAccountApplyList.push({
        LedgerAccountId: TaxLedgerAccount.ledgerAccountID,
        ledgerAccountName: TaxLedgerAccount.ledgerAccountName
      });
      scope.ledgerAccountApplyList = scope.ledgerAccountApplyList.sort((a,b) => a.ledgerAccountName.localeCompare(b.ledgerAccountName))
      var taxLedgerAccountsListIndex = scope.taxLedgerAccountsList.indexOf(
        TaxLedgerAccount
      );
      if (taxLedgerAccountsListIndex > -1) {
        scope.taxLedgerAccountsList.splice(taxLedgerAccountsListIndex, 1);
      }
    },

    removeAppliedLedgerAccount(AppliedTax) {
      let scope = this;
      
      var ledgerAccountApplyListIndex = scope.ledgerAccountApplyList.indexOf(
        AppliedTax
      );
      if (ledgerAccountApplyListIndex > -1) {
        scope.ledgerAccountApplyList.splice(ledgerAccountApplyListIndex, 1);
      }
      scope.taxLedgerAccountsList.push({
        ledgerAccountID: AppliedTax.LedgerAccountId,
        ledgerAccountName: AppliedTax.ledgerAccountName,
        LedgerAccountTypeName: AppliedTax.ledgerAccountName
      });
    },

    displayCategory: function(taxItemCategoryId) {
      console.log(taxItemCategoryId);
      let scope = this;
      if (taxItemCategoryId && taxItemCategoryId != -1) {
        var category = scope.ledgerAccountList
          .filter(x => x.ledgerAccountID === taxItemCategoryId)
          .map(x => x);
        console.log(category[0]);
        scope.categoryName = category[0].ledgerAccountName;
      }
    }
  },

  computed: {
    fncIsTaxItemSave() {
      let vm = this;
      if (vm.$route.params.taxId === "-1") {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncTaxItemSave"
        )
          ? vm.$store.state.userEntitlementList.fncTaxItemNew
          : null;
      } else if (vm.$route.params.taxId > 0) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fnctaxItemUpdate"
        )
          ? vm.$store.state.userEntitlementList.fnctaxItemUpdate
          : null;
      }
    }
  },

  mounted() {
    let vm = this;

    vm.getTaxDetailByid();
    vm.getpropertyId();
    vm.getStatusIdInList();
    $(document).click(function(e) {
      console.log("clicked on doc");
      $("#taxDropDown").hide();
      // vm.showLedgerAccounts = false;
      // vm.showAmenitiesList =false;
    });
  },
  beforeDestroy() {
    // $(document).unbind( "click");
  }
};
</script>